module.exports = __webpack_public_path__ + "static/jest-about-4f2ad213c34a740ae7910fc847e27018.jpg";